import { decode } from '@googlemaps/polyline-codec';
import { memo } from 'react';
import { Layer, Source } from 'react-map-gl/mapbox';
import { useRecoilValue } from 'recoil';
import { FENCES_LAYER_STYLE, FENCES_NAME_LAYER_STYLE, FENCES_OUTLINE_LAYER_STYLE } from '../../../constants/map';
import { notificationSelectedState } from '../../../storage/notifications';

function NotificationLayer() {
  const selectedNotification = useRecoilValue(notificationSelectedState);

  if (!selectedNotification?.extraData?.polygon && !selectedNotification?.extraData?.encodedPolygon) return null;

  const geojson: GeoJSON.Feature = {
    type: 'Feature',
    properties: {},
    geometry: {
      type: 'Polygon',
      coordinates: selectedNotification?.extraData?.encodedPolygon
        ? [
            decode(selectedNotification.extraData.encodedPolygon).map((point) => {
              return [point[1], point[0]];
            }),
          ]
        : selectedNotification?.extraData?.polygon.coordinates,
    },
  };

  return (
    <Source
      type="geojson"
      data={geojson}
      id="routing"
    >
      <Layer {...FENCES_LAYER_STYLE} />
      <Layer {...FENCES_OUTLINE_LAYER_STYLE} />
      <Layer {...FENCES_NAME_LAYER_STYLE} />
    </Source>
  );
}

export default memo(NotificationLayer);
